import * as ActionTypes from './ActionTypes'
import { Map } from 'immutable'

const getInitialState = () => {
  return Map({
    shouldUpdate: false,
    shouldShowUpdateModal: false,
    updateAvailable: false,
  })
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case ActionTypes.VNUPDATE_MANAGER_SET_SHOULD_UPDATE:
      return state.set('shouldUpdate', action.shouldUpdateValue)

    case ActionTypes.VNUPDATE_MANAGER_SET_SHOULD_SHOW_UPDATE_MODAL:
      return state.set('shouldShowUpdateModal', action.shouldShowUpdateModalValue)

    case ActionTypes.VNUPDATE_MANAGER_SET_UPDATE_AVAILABLE:
      return state.set('updateAvailable', action.updateAvailableValue)

    default:
      return state
  }
}

export default reducer
